var swal = require('sweetalert2');

module.exports = function () {

    function generateNewItemFields(data) {

        var categories='';

        for( var category in data['breakdown'] ){
            var cat=
                '<tr>'+
                '<td>'+ category +'</td>'+
                '<td>£ '+ data['breakdown'][category] +' </td>'+
                '</tr>';
            categories+=cat;
        }

        var newFieldGroup =
            '<div id="'+ data['year'] +'" class="row tab-pane" style="color: #000;">'+
                '<div class="col-md-6 hidden-print">'+
                    '<div class="detail-box">'+
                        '<table class="table-budget">'+
                            '<tbody>'+
                                '<tr>'+
                                    '<td><h3>'+ data['departmentName'] +' Budget  </h3></td>'+
                                    '<td></td>'+
                                '</tr>'+
                                '<tr>'+
                                    '<td><b>Overall Budget '+ data['year'] +' :</b></td>'+
                                    '<td class="js-budget-update-amount" data-id="'+ data['id'] +'" data-field="amount" ><b>£ 0 </b><span class="badge badge-primary" style="margin-left:10px;padding-left: 6px; cursor: pointer;"> edit </span></td>'+
                                '</tr>'+
                                '<tr>'+
                                    '<td><b>Breakdown:</b></td>'+
                                    '<td></td>'+
                                '</tr>'+
                                categories +
                                '<tr>'+
                                    '<td><b>Total Spent '+ data['year'] +' :</b></td>'+
                                    '<td><b>£ '+ data['total_spent'] +' </b></td>'+
                                '</tr>'+
                                '<tr>'+
                                    '<td><b>Remaining Budget '+ data['year'] +' :</b></td>'+
                                    '<td><b id="'+ data['id'] +'-remaining">£ 0 </b></td>'+
                                '</tr>'+
                            '</tbody>'+
                        '</table>'+
                    '</div>'+
                '</div>'+
                '<div class="col-md-6 hidden-print">'+
                '<div class="panel-title title-standard">'+
                    '<h3>'+ data['departmentName'] +' Budget Notes for '+ data['year'] +'</h3>'+
                '</div>'+
                '<div class="panel-group border-down margin-down">'+
                    '<textarea class="form-control js-budget-update-field width-100" lines="10" data-id="' + data['id'] + '" data-field="notes" name="notes" cols="50" rows="10"></textarea>'+
                    '<span id="edited-budget-notes" class="pull-left" style="font-size: smaller;"><i>Last edited by</i></span>'+
                '</div>'+
                '</div>'+
                '</div>'+
            '<br>';

        return newFieldGroup;
    }

    $(document).ready(function () {

        var year = $('.btn-add').data('year');
        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        $(document).on('click', '.btn-add', function (e) {

            var departmentId = $(this).data('departmentid');
            var url = '/api/budgets/create-next';
            var data = {
                departmentId: departmentId,
            };

            var success = function (response) {
                var newFieldGroup = generateNewItemFields(response);
                $('<li><a data-toggle="tab" href="#'+ year +'">'+ year +'</a></li>').prependTo('.nav-tabs');
                $(newFieldGroup).appendTo('.tab-content');
            };
            var error = function (response) {
                //console.log('Error');
            };

            e.preventDefault();

            swal({
                title: "Are you sure you want to add budget for year " + (year + 1) + " ?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).then(function(result) {
                if (result.value) {
                    year++;
                    AjaxController.prototype.send(url, data, success, error);
                }
            });
        })
    });

}();
